enum RepositoryPage {
  Airport = 'Airport',
  Member = 'Member',
  Public = 'Public',
}

export default RepositoryPage;
